import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { ViewComponent } from "@frui.ts/views";
import BankTransferViewModel from "viewModels/common/payment/bankTransferViewModel";
import InstructionCard from "./instructionCard";

const InstructionSelect: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  if (!vm.paymentTypeOptions || vm.paymentTypeOptions.length <= 1) {
    return null;
  }

  return (
    <fieldset className="mb-4 form-row">
      <Form.Group as={Col} xs={12} className="m-0">
        <div className="pb-4" style={{ borderBottom: "1px solid #BDC7D1" }}>
          <Form.Row className="align-items-stretch">
            {vm.paymentTypeOptions.map(option => (
              <Form.Group as={Col} key={option.id} sm={12} xl={6} className="d-flex mb-2 pr-2 pl-2">
                <InstructionCard vm={vm} option={option} />
              </Form.Group>
            ))}
          </Form.Row>
        </div>
      </Form.Group>
    </fieldset>
  );
});

export default InstructionSelect;
